const CONST_VARIANT = {
  MUI_DEFAULT: 'MUI_DEFAULT',
  KC_DEFAULT: 'KC_DEFAULT',
  DISABLED: 'DISABLED',
}

const MUI_LICENSE = 'e59beddabe0b5c2087b7335857d90b2bTz05NzA4MixFPTE3NTY0ODMwOTEwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=';

export { CONST_VARIANT, MUI_LICENSE };